<template>
    <div :class="['page-control', {'page-control--centered': centered}, {'page-control--margin-bottom': marginBottom}]">
        <button :disabled="disabled" class="page-control__button" v-if="button">
            {{ label }}
        </button>

        <a :href="href ? href : '#'" class="page-control__link" v-if="link">
            {{ label }}
        </a>
    </div>
</template>

<script>
export default {
    props: {
        centered: Boolean,
        button: Boolean,
        link: Boolean,
        label: String,
        href: String,
        marginBottom: Boolean,
        disabled: Boolean,
    },
}
</script>
